'use client';

import { type FormControlProps } from '@ironhack/design-system2/components/form-control';
import { FormField } from '@ironhack/design-system2/components/form-field';
import { Select } from '@ironhack/design-system2/components/select';
import { type ReactElement } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

type Props = {
  label?: string;
  error?: string;
  name: string;
  isRequired: boolean;
  placeholder: string;
  options: Array<{ key: string; text: string }>;
} & FormControlProps;

export const SelectField = (props: Props): ReactElement => {
  const {
    error,
    isRequired,
    label,
    name,
    options,
    placeholder,
    color = 'text.primary',
    textTransform,
    ...formFieldProps
  } = props;
  const { control } = useFormContext();
  return (
    <FormField
      error={error ?? ''}
      isInvalid={Boolean(error)}
      isRequired={isRequired}
      label={label}
      name={name}
      {...formFieldProps}
    >
      <Controller
        control={control}
        defaultValue={false}
        name={name}
        render={({ field: { onBlur, onChange, value, ref } }) => (
          <Select
            color={color}
            onBlur={onBlur}
            onChange={onChange}
            placeholder={placeholder}
            ref={ref}
            textTransform={textTransform}
            value={value as string}
          >
            {options.map(({ text, key }) => (
              <option key={key} value={key}>
                {text}
              </option>
            ))}
          </Select>
        )}
        rules={{ required: isRequired }}
      />
    </FormField>
  );
};
